export const actions = {
  AUTH_MESSAGE_ACTION({ commit }) {
    commit("MESSAGE_MUTATION", "updated message");
  },
};
